module.exports = __webpack_public_path__ + "img/lv_success_2.31ffbc1d.png";